import React from 'react';

export default React.createContext({
    user: {},
    profile: {},
    logout: () => {},
    showMenu: () => {},
    hideMenu: () => {}
});